export default __webpack_public_path__ + "static/media/delhi.da7fded3.svg";